import Image from 'next/image';

import logoSrc from './cursor-insight-logo.svg';

const Logo = () => (
  <Image src={logoSrc} alt="Cursor Insight Logo" sizes="180px" />
);

export default Logo;
